import { IAppState } from 'shared/common/state';

export const selectEarlyAccessEnabled = (state: IAppState) => Boolean(state.earlyAccessData?.isEarlyAccessEnabled);
